var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchTikTok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 60,
  fill: "none",
  viewBox: "0 0 59 60"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21.048,
  cy: 21.048,
  r: 20.048,
  stroke: "#fff",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.047,
  cy: 21.047,
  r: 6.016,
  stroke: "#fff",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M33.387 37.99c-1.615-4.225-5.664-7.34-10.562-7.612-5.567-.31-10.452 3.151-12.058 8.113M50.513 56.606c1.21 1.626 3.6 1.894 5.339.6s2.167-3.66.958-5.286M50.669 56.782l-17.345-19.09M57.208 52.45 37.91 31.83"
})));
export { SvgSearchTikTok as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA1OSA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjEuMDQ3OCIgY3k9IjIxLjA0NzgiIHI9IjIwLjA0NzgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIyMS4wNDcyIiBjeT0iMjEuMDQ3MiIgcj0iNi4wMTU5MyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMy4zODcgMzcuOTg5NEMzMS43NzIgMzMuNzY1MSAyNy43MjI4IDMwLjY1MDggMjIuODI0OSAzMC4zNzgyQzE3LjI1NzkgMzAuMDY4NSAxMi4zNzMyIDMzLjUyOSAxMC43NjY3IDM4LjQ5MDciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNTAuNTEzMyA1Ni42MDYzQzUxLjcyMyA1OC4yMzE3IDU0LjExMzEgNTguNTAwMyA1NS44NTE4IDU3LjIwNjNDNTcuNTkwNSA1NS45MTIzIDU4LjAxOTQgNTMuNTQ1NyA1Ni44MDk3IDUxLjkyMDMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNTAuNjY4OSA1Ni43ODE4TDMzLjMyNDIgMzcuNjkxNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik01Ny4yMDgxIDUyLjQ0OTVMMzcuOTEwMiAzMS44MzAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";